import { StandardEvents } from '@shopify/events';

class KamaProductSpecifications extends HTMLElement {
  connectedCallback() {
    document.addEventListener(StandardEvents.productSelect, this.onProductSelect);
    this.showVariant(this.dataset.selectedVariant);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.productSelect, this.onProductSelect);
  }

  showVariant(id) {
    let populated = false;
    this.querySelectorAll('[data-spec-variant]').forEach(panel => {
      panel.hidden = panel.dataset.specVariant !== String(id);
      if (!panel.hidden && panel.querySelector('dt')) populated = true;
    });
    this.hidden = !populated;
    const accordion = this.closest('details[data-kama-specifications]');
    if (accordion) accordion.hidden = !populated;
  }

  onProductSelect = async event => {
    if (!(event.target instanceof Element) || event.target.closest('product-card, dialog')) return;
    const sequence = this.sequence = (this.sequence || 0) + 1;
    try {
      const { detail } = await event.promise;
      if (sequence !== this.sequence || !detail || String(detail.productId) !== this.dataset.productId) return;
      this.showVariant(detail.resource?.id || '');
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[kama-product-specifications]', error);
    }
  };
}

if (!customElements.get('kama-product-specifications')) {
  customElements.define('kama-product-specifications', KamaProductSpecifications);
}
